// removed by extract-text-webpack-plugin
module.exports = {"trade-category-container":"trade-category-container","trade-category-wrap":"trade-category-wrap","trade-left-content":"trade-left-content","title-black":"title-black","trade-right-content":"trade-right-content","trade-item":"trade-item","trade-name":"trade-name","wrap-image":"wrap-image","trade-news-left-content":"trade-news-left-content","trade-news-right-content":"trade-news-right-content"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_TradeNewsContainer.scss
// module id = ./components/home/sub-view/_TradeNewsContainer.scss
// module chunks = 0